module.exports = __webpack_public_path__ + "static/img/banner_after (1).e13c42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_after (1).png
// module id = JP2V
// module chunks = 16